import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { LoadingButton } from '../common/LoadingButton';
import { IUserMenuItem, PortalApiRoutes, PortalRoutes } from '../../types/portalTypes';
import React from 'react';
import { faSquareCaretLeft, faSquareCaretRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SidebarProps {
    onLoggedOut: any
    userMenu?: IUserMenuItem[]
}

export const Sidebar = ({ onLoggedOut, userMenu }: SidebarProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const history = useHistory();

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const handleLogout = async () => {
        try {
            setIsLoggingOut(true)
            const response = await axios.get(PortalApiRoutes.ACCOUNT_LOGOUT)
            if (response.status === 200) {
                // Logout successful, redirect to login page
                history.push(PortalRoutes.ACCOUNT_LOGIN)

                if (onLoggedOut) {
                    onLoggedOut()
                }

                setIsLoggingOut(false)
            }
        } catch (error) {
            console.error('Logout failed:', error)
        }
    };

    return (
        <div className={`flex flex-col bg-gray-800 dark:bg-neutral-900 text-white ${isCollapsed ? 'w-16' : 'w-48'} transition-width duration-300
        sticky top-0 h-screen z-[999]`}>
            <div className="p-4 mb-4">
                {!isCollapsed &&
                    <img src="/img/logo_white.png" alt="TrueVote" className="w-48" />
                }

            </div>

            <nav className="flex-1">
                {!isCollapsed && userMenu && userMenu.map((menuItem: IUserMenuItem, index: number) => (
                    <div key={menuItem.name || index} className="relative group">
                        {menuItem.url ? (
                            menuItem.isExternal ? (
                                <a className="block hover:bg-gray-700 dark:hover:bg-neutral-700 px-4 py-2 text-white"
                                    href={menuItem.url}
                                    target="_blank"
                                    rel="noreferrer">{menuItem.name}</a>
                            ) : (
                                <Link className="block hover:bg-gray-700 dark:hover:bg-neutral-700 px-4 py-2 text-white"
                                    to={menuItem.url}>{menuItem.name}</Link>
                            )
                        ) : (
                            <span className="block hover:bg-gray-700 dark:hover:bg-neutral-700 px-4 py-2 text-white cursor-default">{menuItem.name}</span>
                        )}
                        {menuItem.subMenu && (
                            <div className="absolute left-full top-0 hidden group-hover:block bg-gray-700 dark:bg-neutral-700 border border-gray-600 dark:border-neutral-600 rounded shadow-lg">
                                {menuItem.subMenu.map((subMenuItem: IUserMenuItem, subIndex: number) => (
                                    subMenuItem.url ? (
                                        subMenuItem.isExternal ? (
                                            <a key={subIndex}
                                                className="block whitespace-nowrap px-4 py-2 hover:bg-gray-600 dark:hover:bg-neutral-600 text-white min-w-[200px]"
                                                href={subMenuItem.url}
                                                target="_blank"
                                                rel="noreferrer">{subMenuItem.name}</a>
                                        ) : (
                                            <Link key={subIndex}
                                                className="block whitespace-nowrap px-4 py-2 hover:bg-gray-600 dark:hover:bg-neutral-600 text-white min-w-[200px]"
                                                to={subMenuItem.url}>{subMenuItem.name}</Link>
                                        )
                                    ) : (
                                        <span key={subIndex}
                                            className="block whitespace-nowrap px-4 py-2 text-white cursor-default">{subMenuItem.name}</span>
                                    )
                                ))}
                            </div>
                        )}
                    </div>
                )
                )}
            </nav>

            <div className="flex justify-between items-center p-4 mb-4">
                {!isCollapsed &&
                    <LoadingButton
                        btnText="Logout"
                        className="block mb-2 text-white text-left"
                        isLoading={isLoggingOut}
                        onBtnClick={handleLogout} />
                }
                <button className="ml-2" onClick={toggleSidebar}>
                    {isCollapsed ? <FontAwesomeIcon icon={faSquareCaretRight} /> : <FontAwesomeIcon icon={faSquareCaretLeft} />}
                </button>
            </div>

        </div>
    );
}